import { AdminRouteName } from '../../../CONSTANTS';
import GuaranteesTableRecords from '../../_partials/GuaranteesTableRecords';

const optionalColumn = [
  'datePaid',
  'dateActioned',
];

const optionalColumnLabelFormat = {
  datePaid: 'Date Paid',
  dateActioned: 'Date Actioned',
};

const DeclinedPreApprovalGuarantees = (
  { TabsRaw }: any,
) => (
  <GuaranteesTableRecords
    type="pre-approval"
    TabsRaw={TabsRaw}
    optionalColumn={optionalColumn}
    optionalColumnLabelFormat={optionalColumnLabelFormat}
    defaultUrl={AdminRouteName.declinedPreApprovalGuaranteesRoute}
    tabStatus="REFUNDED"
    toggleStorageId="declined-pre-approval-guarantee-table-col"
    hasNameAndImage
    permissionName="can-view-declined-guarantees"
  />

);

export default DeclinedPreApprovalGuarantees;
